import { ready } from './utils'
import axios     from 'axios'

const payload = {
    recipient: '',
    name: '',
    email: '',
    phone: '',
    message: ''
}

const contact = {
    ask: (endpoint, payload) => {
        return new Promise((resolve, reject) => {
            axios.post(endpoint, payload).then((response) => {
                resolve(response.data)
            }).catch(err => reject({
                status: 'Error',
                message: err.message
            }))
        })
    },
    onChange: (field, event) => payload[field] = event.target.value,
	init: () => ready(() => {
        const endpoint = `${ location.origin }/api/v1/contact-us/send-email`
        const form = document.querySelector('#contact-form')

        if (form) {
            const submit = form.querySelector('.btn-brown')
            const select = form.querySelector('select.input')
            const inputs = form.querySelectorAll('input.input')
            const textarea = form.querySelector('textarea.input')

            const errorWrapper = form.querySelector('.fn-error')
            let formError = false

            if (select && inputs.length > 0 && textarea) {
                select.addEventListener('change', contact.onChange.bind(null, 'recipient'), false)
                inputs[0].addEventListener('change', contact.onChange.bind(null, 'name'), false)
                inputs[1].addEventListener('change', contact.onChange.bind(null, 'email'), false)
                inputs[2].addEventListener('change', contact.onChange.bind(null, 'phone'), false)
                textarea.addEventListener('change', contact.onChange.bind(null, 'message'), false)

                // Trig select event on init
                select.dispatchEvent(new Event('change'))

                // Submit
                submit.addEventListener('click', () => {
                    const keys = Object.keys(payload)

                    // Prevent to spam the submit btn
                    submit.classList.add('disabled')
                    // User can submit every 2nd second.
                    setTimeout(() => submit.classList.remove('disabled'), 2000)

                    keys.forEach((key) => {
                        if (payload[key].length <= 0 || payload[key] === '') {
                            if (key === 'name') {
                                formError = true
                                inputs[0].nextElementSibling.classList.remove('hidden')
                            }

                            if (key === 'email') {
                                formError = true
                                inputs[1].nextElementSibling.classList.remove('hidden')
                            }

                            if (key === 'phone') {
                                formError = true
                                inputs[2].nextElementSibling.classList.remove('hidden')
                            }

                            if (key === 'message') {
                                formError = true
                                textarea.nextElementSibling.classList.remove('hidden')
                            }
                        } else {
                            if (key === 'name') {
                                formError = false
                                inputs[0].nextElementSibling.classList.add('hidden')
                            }

                            if (key === 'email') {
                                formError = false
                                inputs[1].nextElementSibling.classList.add('hidden')
                            }

                            if (key === 'phone') {
                                formError = false
                                inputs[2].nextElementSibling.classList.add('hidden')
                            }

                            if (key === 'message') {
                                formError = false
                                textarea.nextElementSibling.classList.add('hidden')
                            }
                        }
                    })

                    if (!formError) {
                        contact.ask(endpoint, payload).then((response) => {
                            if (response.status === 'Success') {
                                const success = form.querySelector('.fn-success')

                                success.classList.add('show')

                                setTimeout(() => location.reload(), 5000)
                            }
                        }).catch(err => {
                            errorWrapper.style.display = 'block'
                            setTimeout(() => errorWrapper.style.display = 'none', 5000)
                        })
                    }
                })
            }
        }
	})
}

export default contact
